import FilterChipMixin from './mixin.js';

export const TextFieldFilterChip = {
  mixins: [FilterChipMixin]
};
